/* FizzyIQ — Science benefit rows: animated coral dot-grid graphics (iterations
   of the home bento dot matrix) + optional Rive runtime init. One motion
   pattern per card theme. Sam: 2026-06-22. */
(function () {
  'use strict';

  /* ── dot-grid canvas animator ───────────────────────────────── */
  function wave(v) { return 0.5 + 0.5 * Math.sin(v); }
  function clamp01(x) { return x < 0 ? 0 : (x > 1 ? 1 : x); }
  /* smoothstep 0..1 between e0..e1 (works ascending OR descending) */
  function ss(e0, e1, x) { var u = clamp01((x - e0) / (e1 - e0)); return u * u * (3 - 2 * u); }
  /* distance from point (px,py) to segment (ax,ay)→(bx,by) */
  function segd(px, py, ax, ay, bx, by) {
    var vx = bx - ax, vy = by - ay, wx = px - ax, wy = py - ay;
    var len2 = vx * vx + vy * vy; if (len2 < 1e-6) len2 = 1e-6;
    var h = (wx * vx + wy * vy) / len2; h = h < 0 ? 0 : (h > 1 ? 1 : h);
    var dx = wx - vx * h, dy = wy - vy * h;
    return Math.sqrt(dx * dx + dy * dy);
  }

  /* Per-card dot-matrix icon field → 0..1. Aspect-corrected normalized coords
     (unit = half panel HEIGHT so circles stay round); ny ∈ [-1,1] top→bottom,
     panel center = (0,0). The dense grid resolves each shape; off-shape dots ride
     the faint opacity floor as grid texture. */
  function intensity(p, gx, gy, cols, rows, t) {
    var cx = (cols - 1) / 2, cy = (rows - 1) / 2;
    var unit = (rows - 1) / 2; if (unit < 1e-6) unit = 1e-6;
    var nx = (gx - cx) / unit;
    var ny = (gy - cy) / unit;

    switch (p) {

      case 'absorb': {
        /* CELL-MEMBRANE ABSORPTION: lipid-bilayer double ring (the cell), with a
           hexagonal nutrient molecule slowly migrating from outside, through the
           membrane band, into the cell interior. Reads as uptake / bioavailability.
           t is in seconds → ~12.5s loop via t*0.08. */
        var ab_cR = 0.74;                              // membrane mid-radius
        var ab_cd = Math.sqrt(nx * nx + ny * ny);      // radial distance from cell center
        var ab_half = 0.165;                           // half-thickness of membrane band
        var ab_band = ss(ab_cR + ab_half, ab_cR + ab_half - 0.07, ab_cd) *
                      ss(ab_cR - ab_half, ab_cR - ab_half + 0.07, ab_cd);
        var ab_leafW = 0.052, ab_gap = 0.052;
        var ab_outer = ss(ab_cR + ab_gap + ab_leafW + 0.04, ab_cR + ab_gap + ab_leafW - 0.04, ab_cd) *
                       ss(ab_cR + ab_gap - ab_leafW - 0.04, ab_cR + ab_gap - ab_leafW + 0.04, ab_cd);
        var ab_inner = ss(ab_cR - ab_gap + ab_leafW + 0.04, ab_cR - ab_gap + ab_leafW - 0.04, ab_cd) *
                       ss(ab_cR - ab_gap - ab_leafW - 0.04, ab_cR - ab_gap - ab_leafW + 0.04, ab_cd);
        var ab_membrane = clamp01(Math.max(ab_outer, ab_inner)) * 0.5 + ab_band * 0.55;
        ab_membrane = clamp01(ab_membrane);
        ab_membrane *= 0.90 + 0.10 * wave(t * 0.7 - ab_cd * 2.0); // faint living shimmer

        // nutrient hexagon migrates inward on a calm ~12.5s loop
        var ab_cyc = (t * 0.08) % 1.0;
        var ab_travel = ss(0.0, 0.62, ab_cyc);
        var ab_mx = 1.45 - ab_travel * 1.45;           // x: outside-right -> center
        var ab_my = 0.0;
        var ab_hexR = 0.20;
        var ab_lx = nx - ab_mx, ab_ly = ny - ab_my;
        var ab_hexDist = Math.sqrt(ab_lx * ab_lx + ab_ly * ab_ly);
        var ab_core = ss(ab_hexR * 0.62 + 0.05, ab_hexR * 0.62 - 0.05, ab_hexDist);
        var ab_bonds = 0.0, ab_bw = 0.060;
        for (var ab_k = 0; ab_k < 6; ab_k++) {
          var ab_a = ab_k * 1.0471975512;              // 60deg steps
          var ab_vx = ab_mx + Math.cos(ab_a) * ab_hexR;
          var ab_vy = ab_my + Math.sin(ab_a) * ab_hexR;
          var ab_db = segd(nx, ny, ab_mx, ab_my, ab_vx, ab_vy);
          var ab_bb = ss(ab_bw + 0.045, ab_bw - 0.035, ab_db);
          if (ab_bb > ab_bonds) ab_bonds = ab_bb;
          var ab_dv = Math.sqrt((nx - ab_vx) * (nx - ab_vx) + (ny - ab_vy) * (ny - ab_vy));
          var ab_nv = ss(0.075, 0.025, ab_dv);
          if (ab_nv > ab_bonds) ab_bonds = ab_nv;
        }
        var ab_molecule = clamp01(Math.max(ab_core, ab_bonds * 0.92));

        // interior uptake glow swells as the molecule lands inside
        var ab_landed = ss(0.55, 0.05, ab_mx);
        var ab_interior = ss(ab_cR - ab_half, ab_cR - ab_half - 0.50, ab_cd);
        var ab_glow = ab_interior * ab_landed * (0.30 + 0.30 * wave(t * 1.1));

        return clamp01(Math.max(Math.max(ab_membrane * 0.95, ab_molecule), ab_glow));
      }

      case 'immune': {
        /* ANTIBODY: bold coral Y (Fc stem + two Fab arms), with an antigen dot
           that eases up to the right arm tip and bind-pulses on contact.
           t in seconds → slow recognition heartbeat. */
        var im_hx = 0.0, im_hy = 0.18;                  // hinge
        var im_stemBX = 0.0, im_stemBY = 0.78;          // stem base
        var im_armL = 0.62;
        var im_tipLX = -im_armL, im_tipLY = -0.62;
        var im_tipRX =  im_armL, im_tipRY = -0.62;
        var im_th = 0.16, im_soft = 0.085;

        var im_dStem = segd(nx, ny, im_stemBX, im_stemBY, im_hx, im_hy);
        var im_dArmL = segd(nx, ny, im_hx, im_hy, im_tipLX, im_tipLY);
        var im_dArmR = segd(nx, ny, im_hx, im_hy, im_tipRX, im_tipRY);
        var im_dBody = Math.min(im_dStem, Math.min(im_dArmL, im_dArmR));
        var im_body = ss(im_th + im_soft, im_th - im_soft, im_dBody);

        var im_p = wave(t * 0.7);                        // slow oscillation
        var im_glide = ss(0.0, 1.0, im_p);
        var im_apX = im_tipRX + 0.42, im_apY = im_tipRY - 0.30;      // start off, upper-right
        var im_dockX = im_tipRX + 0.05, im_dockY = im_tipRY + 0.02;  // docked at tip
        var im_agX = im_apX + (im_dockX - im_apX) * im_glide;
        var im_agY = im_apY + (im_dockY - im_apY) * im_glide;

        var im_agR = 0.16;
        var im_dAg = Math.sqrt((nx - im_agX) * (nx - im_agX) + (ny - im_agY) * (ny - im_agY));
        var im_antigen = ss(im_agR + im_soft, im_agR - im_soft, im_dAg);

        var im_bound = ss(0.7, 1.0, im_glide);
        var im_pulse = 0.10 * im_bound * wave(t * 1.6);

        var im_v = Math.max(im_body, im_antigen);
        im_v = im_v + im_pulse * im_v;
        return clamp01(im_v);
      }

      case 'antioxidant': {
        /* POLYPHENOL RING quenching a FREE RADICAL: a hexagonal aromatic ring
           (6 vertex atoms + bonds) left of center; a haloed radical drifts in
           from the right, flares at contact, then is quenched (fades) and respawns.
           t in seconds → ~6s loop via (t*0.16)%1. */
        var ax_hcx = -0.45, ax_hcy = 0.0;               // ring center
        var ax_hr  = 0.62;                               // ring radius
        var ax_vR  = 0.16;                               // vertex atom radius
        var ax_bondW = 0.085;                            // bond half-thickness
        var ax_breathe = 0.85 + 0.15 * wave(t * 0.9);    // slow ring breathing

        var ax_ringV = 0.0;
        var ax_fvx = 0, ax_fvy = 0;                      // quench (far-right) vertex
        for (var ax_i = 0; ax_i < 6; ax_i++) {
          var ax_a0 = (Math.PI / 3) * ax_i - Math.PI / 6;
          var ax_vx0 = ax_hcx + ax_hr * Math.cos(ax_a0);
          var ax_vy0 = ax_hcy + ax_hr * Math.sin(ax_a0);
          var ax_dV = Math.sqrt((nx - ax_vx0) * (nx - ax_vx0) + (ny - ax_vy0) * (ny - ax_vy0));
          if (ss(ax_vR + 0.05, ax_vR - 0.05, ax_dV) > ax_ringV) ax_ringV = ss(ax_vR + 0.05, ax_vR - 0.05, ax_dV);
          var ax_a1 = (Math.PI / 3) * (ax_i + 1) - Math.PI / 6;
          var ax_vx1 = ax_hcx + ax_hr * Math.cos(ax_a1);
          var ax_vy1 = ax_hcy + ax_hr * Math.sin(ax_a1);
          var ax_dB = segd(nx, ny, ax_vx0, ax_vy0, ax_vx1, ax_vy1);
          if (ss(ax_bondW + 0.05, ax_bondW - 0.05, ax_dB) > ax_ringV) ax_ringV = ss(ax_bondW + 0.05, ax_bondW - 0.05, ax_dB);
          if (ax_i === 0) { ax_fvx = ax_vx0; ax_fvy = ax_vy0; }
        }
        ax_ringV *= ax_breathe;

        var ax_ph = (t * 0.16) % 1.0;                    // ~6s phase
        var ax_travel = ss(0.0, 0.55, ax_ph);
        var ax_startX = 1.55, ax_startY = 0.35;
        var ax_rx = ax_startX + (ax_fvx + 0.18 - ax_startX) * ax_travel;
        var ax_ry = ax_startY + (ax_fvy + 0.10 - ax_startY) * ax_travel;

        var ax_contact = ss(0.45, 0.6, ax_ph);
        var ax_fade    = ss(0.6, 0.85, ax_ph);
        var ax_life    = clamp01(1.0 - ax_fade);
        var ax_flare   = 1.0 + 0.9 * ax_contact * (1.0 - ax_fade);

        var ax_dR = Math.sqrt((nx - ax_rx) * (nx - ax_rx) + (ny - ax_ry) * (ny - ax_ry));
        var ax_coreDot = ss(0.11, 0.05, ax_dR);
        var ax_haloR = 0.22 * ax_flare;
        var ax_halo = ss(ax_haloR, ax_haloR - 0.07, ax_dR) * ss(0.06, 0.13, ax_dR) * 0.55;
        var ax_radical = Math.max(ax_coreDot, ax_halo) * ax_life;

        return clamp01(Math.max(ax_ringV, ax_radical));
      }

      case 'mood': {
        /* NEURON SIGNALING: soma + dendrites on the left, a long axon sweeping
           right to a synaptic terminal, and an action-potential pulse travelling
           down the axon and flashing the terminal. t in seconds → ~6s loop. */
        var mo_somaX = -0.95, mo_somaY = 0.0, mo_somaR = 0.34;
        var mo_ax0x = mo_somaX + mo_somaR * 0.6, mo_ax0y = mo_somaY;  // axon start
        var mo_axmx = 0.25, mo_axmy = 0.10;                            // bend midpoint
        var mo_ax1x = 1.25, mo_ax1y = 0.28;                            // synapse end
        var mo_axW  = 0.085;

        var mo_dS = Math.sqrt((nx - mo_somaX) * (nx - mo_somaX) + (ny - mo_somaY) * (ny - mo_somaY));
        var mo_v = ss(mo_somaR + 0.05, mo_somaR - 0.05, mo_dS);

        var mo_dend = function (bx, by) {
          var d = segd(nx, ny, mo_somaX, mo_somaY, bx, by);
          return ss(0.085, 0.025, d);
        };
        mo_v = Math.max(mo_v, mo_dend(mo_somaX - 0.55, mo_somaY - 0.55)); // up-left
        mo_v = Math.max(mo_v, mo_dend(mo_somaX - 0.62, mo_somaY + 0.02)); // left
        mo_v = Math.max(mo_v, mo_dend(mo_somaX - 0.45, mo_somaY + 0.60)); // down-left
        mo_v = Math.max(mo_v, mo_dend(mo_somaX - 0.05, mo_somaY - 0.66)); // up

        var mo_dA1 = segd(nx, ny, mo_ax0x, mo_ax0y, mo_axmx, mo_axmy);
        var mo_dA2 = segd(nx, ny, mo_axmx, mo_axmy, mo_ax1x, mo_ax1y);
        var mo_dAx = Math.min(mo_dA1, mo_dA2);
        var mo_axonBand = ss(mo_axW + 0.04, mo_axW - 0.02, mo_dAx);
        mo_v = Math.max(mo_v, mo_axonBand * 0.55);

        var mo_dT = Math.sqrt((nx - mo_ax1x) * (nx - mo_ax1x) + (ny - mo_ax1y) * (ny - mo_ax1y));
        mo_v = Math.max(mo_v, ss(0.20, 0.12, mo_dT));

        var mo_p = (t * 0.1667) % 1.0;                  // ~6s along axon
        var mo_px, mo_py;
        if (mo_p < 0.5) { var mo_u1 = mo_p / 0.5; mo_px = mo_ax0x + (mo_axmx - mo_ax0x) * mo_u1; mo_py = mo_ax0y + (mo_axmy - mo_ax0y) * mo_u1; }
        else            { var mo_u2 = (mo_p - 0.5) / 0.5; mo_px = mo_axmx + (mo_ax1x - mo_axmx) * mo_u2; mo_py = mo_axmy + (mo_ax1y - mo_axmy) * mo_u2; }
        var mo_dPulse = Math.sqrt((nx - mo_px) * (nx - mo_px) + (ny - mo_py) * (ny - mo_py));
        var mo_pulse = ss(0.26, 0.04, mo_dPulse) * mo_axonBand;
        mo_v = Math.max(mo_v, mo_pulse);

        var mo_arrive = ss(0.78, 0.97, mo_p) * ss(1.0, 0.97, mo_p);
        mo_v = Math.max(mo_v, ss(0.22, 0.14, mo_dT) * (0.6 + 0.4 * mo_arrive));

        mo_v *= 0.92 + 0.08 * wave(t * 0.6);            // gentle breathing
        return clamp01(mo_v);
      }

      case 'synergy': {
        /* STRUCTURAL FORMULA: a hub atom bonded to 4 satellites + 1 terminal
           branch atom, with a soft pulse gliding along every bond. Reads as a
           synergistic bonded compound. t in seconds. */
        var sy_hx = 0.0, sy_hy = 0.0;                   // hub
        var sy_ax = -0.78, sy_ay = -0.46;
        var sy_bx =  0.74, sy_by = -0.50;
        var sy_cx =  0.86, sy_cy =  0.40;
        var sy_dx = -0.62, sy_dy =  0.52;
        var sy_ex =  1.38, sy_ey =  0.02;               // terminal branch

        var sy_breath = 1.0 + 0.05 * wave(t * 0.7);
        var sy_rHub = 0.30 * sy_breath;
        var sy_rAtom = 0.20 * sy_breath;
        var sy_rTerm = 0.15 * sy_breath;
        var sy_aa = 0.10;

        var sy_atom = function (cxp, cyp, r) {
          var d = Math.sqrt((nx - cxp) * (nx - cxp) + (ny - cyp) * (ny - cyp));
          return ss(r, r - sy_aa, d);
        };
        var sy_bw = 0.075;
        var sy_bond = function (x0, y0, x1, y1) {
          var d = segd(nx, ny, x0, y0, x1, y1);
          return ss(sy_bw, sy_bw - sy_aa, d);
        };
        var sy_sweep = wave(t * 0.9);
        var sy_shimmer = function (x0, y0, x1, y1) {
          var dx2 = x1 - x0, dy2 = y1 - y0;
          var L2 = dx2 * dx2 + dy2 * dy2;
          if (L2 < 1e-6) return 0;
          var u = ((nx - x0) * dx2 + (ny - y0) * dy2) / L2;
          if (u < 0 || u > 1) return 0;
          var dperp = segd(nx, ny, x0, y0, x1, y1);
          var onLine = ss(sy_bw + 0.02, 0.0, dperp);
          var band = u - sy_sweep;
          var glow = Math.exp(-(band * band) / 0.012);
          return onLine * glow;
        };

        var sy_v = 0;
        sy_v = Math.max(sy_v, sy_bond(sy_hx, sy_hy, sy_ax, sy_ay));
        sy_v = Math.max(sy_v, sy_bond(sy_hx, sy_hy, sy_bx, sy_by));
        sy_v = Math.max(sy_v, sy_bond(sy_hx, sy_hy, sy_cx, sy_cy));
        sy_v = Math.max(sy_v, sy_bond(sy_hx, sy_hy, sy_dx, sy_dy));
        sy_v = Math.max(sy_v, sy_bond(sy_bx, sy_by, sy_ex, sy_ey)); // branch chain

        sy_v = Math.max(sy_v, sy_atom(sy_hx, sy_hy, sy_rHub));
        sy_v = Math.max(sy_v, sy_atom(sy_ax, sy_ay, sy_rAtom));
        sy_v = Math.max(sy_v, sy_atom(sy_bx, sy_by, sy_rAtom));
        sy_v = Math.max(sy_v, sy_atom(sy_cx, sy_cy, sy_rAtom));
        sy_v = Math.max(sy_v, sy_atom(sy_dx, sy_dy, sy_rAtom));
        sy_v = Math.max(sy_v, sy_atom(sy_ex, sy_ey, sy_rTerm));

        var sy_sh = 0;
        sy_sh = Math.max(sy_sh, sy_shimmer(sy_hx, sy_hy, sy_ax, sy_ay));
        sy_sh = Math.max(sy_sh, sy_shimmer(sy_hx, sy_hy, sy_bx, sy_by));
        sy_sh = Math.max(sy_sh, sy_shimmer(sy_hx, sy_hy, sy_cx, sy_cy));
        sy_sh = Math.max(sy_sh, sy_shimmer(sy_hx, sy_hy, sy_dx, sy_dy));
        sy_sh = Math.max(sy_sh, sy_shimmer(sy_bx, sy_by, sy_ex, sy_ey));
        sy_v = clamp01(sy_v + 0.45 * sy_sh);

        return sy_v;
      }

      default:
        return wave((nx + ny) * 2.0 - t * 1.2);
    }
  }

  var ZERO = { addOp: 0, rMul: 1 };

  /* ── per-card CLICK reaction (motif-complementing) ──────────────
     ci eases 1→0 over ~1.6s (driven by the integrator). cnx,cny = click point in
     motif space; tSince = seconds since click; t = global clock. Every branch is
     ci/tSince-gated so it settles fully to {0,1}. Returns {addOp,rMul}.
     NOTE the signature is motif-space now (not css-px). Sam: 2026-06-24. */
  function reaction(pattern, nx, ny, v, cnx, cny, ci, tSince, t) {
    switch (pattern) {
      case 'absorb': {
        // transient nutrient flood: inward-collapsing shell + center bloom + membrane flare.
        var rr = Math.hypot(nx, ny);
        var travel = 0.6 * (1 - ci);
        var shell = ss(0.20, 0.0, Math.abs(rr - travel));
        var swell = ss(0.0, 0.5, ci) * ss(1.0, 0.5, ci) * 4;
        var bloom = ss(0.55, 0.0, rr) * clamp01(swell);
        var onRing = ss(0.16, 0.0, Math.abs(rr - 0.6));
        var flare = onRing * ss(0.55, 1.0, ci);
        var amt = ci * (0.80 * shell + 0.70 * bloom + 0.50 * flare);
        return { addOp: clamp01(amt) * 0.9, rMul: 1 + 0.7 * clamp01(amt) };
      }
      case 'immune': {
        if (ci <= 0) return ZERO;
        var tipLx = -0.62, tipLy = -0.30, tipRx = 0.62, tipRy = -0.30;
        var hinx = 0.0, hiny = 0.18;
        var dL = (cnx - tipLx) * (cnx - tipLx) + (cny - tipLy) * (cny - tipLy);
        var dR = (cnx - tipRx) * (cnx - tipRx) + (cny - tipRy) * (cny - tipRy);
        var btx = dL < dR ? tipLx : tipRx, bty = dL < dR ? tipLy : tipRy;
        var rd = Math.sqrt((nx - btx) * (nx - btx) + (ny - bty) * (ny - bty));
        var front = tSince * 1.6;
        var ring = (1.0 - ss(0.0, 0.16, Math.abs(rd - front))) * ci;
        var clamp = (1.0 - ss(0.0, 0.22, rd)) * ci * (1.0 - ss(0.0, 0.45, tSince));
        var armD = segd(nx, ny, hinx, hiny, btx, bty);
        var armFlare = (1.0 - ss(0.0, 0.15, armD)) * ci * 0.7;
        var addOp = 0.6 * ring + 0.85 * clamp + 0.5 * armFlare;
        var rMul = 1.0 + 0.5 * ring + 0.6 * clamp + 0.45 * armFlare;
        if (addOp > 0.9) addOp = 0.9;
        if (rMul > 2) rMul = 2;
        return { addOp: addOp, rMul: rMul };
      }
      case 'antioxidant': {
        // shockwave always emanates from the ring center, regardless of click point.
        var rcx = -0.45, rcy = 0.0;
        var dRing = Math.hypot(nx - rcx, ny - rcy);
        var radius = (1.0 - ci) * 1.4;
        var ring = ss(0.20, 0.0, Math.abs(dRing - radius));
        var core = ss(0.30, 0.0, dRing) * ss(0.0, 0.35, ci);
        var spark = 0.6 + 0.4 * wave(t * 5.0 + dRing * 8.0);
        var motif = 0.4 + 0.6 * v;
        var amp = ci * motif * (ring * 0.8 * spark + core * 0.9);
        return { addOp: clamp01(0.9 * amp), rMul: 1.0 + 0.9 * clamp01(amp) };
      }
      case 'mood': {
        if (ci <= 0 || tSince > 1.6) return ZERO;
        var c_ax0x = -0.95 + 0.34 * 0.6, c_ax0y = 0.0;
        var c_axmx = 0.25, c_axmy = 0.10;
        var c_ax1x = 1.25, c_ax1y = 0.28;
        var c_axW = 0.085;
        var c_dA1 = segd(nx, ny, c_ax0x, c_ax0y, c_axmx, c_axmy);
        var c_dA2 = segd(nx, ny, c_axmx, c_axmy, c_ax1x, c_ax1y);
        var c_dAx = c_dA1 < c_dA2 ? c_dA1 : c_dA2;
        var c_band = ss(c_axW + 0.05, c_axW - 0.02, c_dAx);
        var c_p = clamp01(tSince / 0.55);
        c_p = c_p * c_p * (3 - 2 * c_p);
        var c_px, c_py;
        if (c_p < 0.5) { var c_u1 = c_p / 0.5; c_px = c_ax0x + (c_axmx - c_ax0x) * c_u1; c_py = c_ax0y + (c_axmy - c_ax0y) * c_u1; }
        else { var c_u2 = (c_p - 0.5) / 0.5; c_px = c_axmx + (c_ax1x - c_axmx) * c_u2; c_py = c_axmy + (c_ax1y - c_axmy) * c_u2; }
        var c_dPulse = Math.sqrt((nx - c_px) * (nx - c_px) + (ny - c_py) * (ny - c_py));
        var c_crest = ss(0.24, 0.04, c_dPulse) * c_band;
        var c_dT = Math.sqrt((nx - c_ax1x) * (nx - c_ax1x) + (ny - c_ax1y) * (ny - c_ax1y));
        var c_arrive = ss(0.42, 0.6, tSince) * ss(1.05, 0.6, tSince);
        var c_flash = ss(0.26, 0.10, c_dT) * c_arrive;
        var c_wash = c_band * 0.18;
        var c_lit = (Math.max(c_crest, c_flash) + c_wash) * ci;
        return { addOp: 0.9 * c_lit, rMul: 1 + 0.95 * c_lit };
      }
      case 'synergy': {
        if (ci <= 0) return ZERO;
        var C_hx = 0.0, C_hy = 0.0;
        var C_ax = -0.78, C_ay = -0.46;
        var C_bx = 0.74, C_by = -0.50;
        var C_cx = 0.86, C_cy = 0.40;
        var C_dx = -0.62, C_dy = 0.52;
        var C_ex = 1.38, C_ey = 0.02;
        var FRONT = tSince * 2.6;
        var SHELL = 0.34;
        var dN = segd(nx, ny, C_hx, C_hy, C_ax, C_ay);
        dN = Math.min(dN, segd(nx, ny, C_hx, C_hy, C_bx, C_by));
        dN = Math.min(dN, segd(nx, ny, C_hx, C_hy, C_cx, C_cy));
        dN = Math.min(dN, segd(nx, ny, C_hx, C_hy, C_dx, C_dy));
        dN = Math.min(dN, segd(nx, ny, C_bx, C_by, C_ex, C_ey));
        var onNet = ss(0.16, 0.03, dN);
        var rHub = Math.sqrt(nx * nx + ny * ny);
        var g = rHub - FRONT;
        var ring = Math.exp(-(g * g) / (2 * SHELL * SHELL));
        var C_atom = function (ax, ay) {
          var d = Math.sqrt((nx - ax) * (nx - ax) + (ny - ay) * (ny - ay));
          var ar = Math.sqrt(ax * ax + ay * ay); var ag = ar - FRONT;
          return ss(0.26, 0.06, d) * Math.exp(-(ag * ag) / (2 * 0.20 * 0.20));
        };
        var flare = 0;
        flare = Math.max(flare, C_atom(C_ax, C_ay));
        flare = Math.max(flare, C_atom(C_bx, C_by));
        flare = Math.max(flare, C_atom(C_cx, C_cy));
        flare = Math.max(flare, C_atom(C_dx, C_dy));
        flare = Math.max(flare, C_atom(C_ex, C_ey));
        var hubFlash = ss(0.30, 0.05, rHub) * Math.exp(-(tSince * tSince) / (2 * 0.12 * 0.12));
        var env = ci * ci;
        var addOp = env * (0.70 * ring * onNet + 0.55 * flare + 0.45 * hubFlash) * (0.45 + 0.55 * v);
        if (addOp > 0.9) addOp = 0.9; if (addOp < 0) addOp = 0;
        var rMul = 1 + env * (0.80 * ring * onNet + 0.65 * flare + 0.50 * hubFlash);
        if (rMul > 2) rMul = 2;
        return { addOp: addOp, rMul: rMul };
      }
      default: return ZERO;
    }
  }

  /* Dense coral dot field (PITCH 13, RAD 3) — each card's bright dots resolve into a
     scientific dot-matrix motif (see intensity(): cell+nutrient, antibody, polyphenol
     ring, neuron, molecule). Click/tap a card to fire its signature reaction (see
     reaction()); off-shape dots ride the faint opacity floor as grid texture.
     Reduced-motion + no-pointer get the calm base animation only. */
  function initDots() {
    var list = document.querySelectorAll('canvas[data-pattern]');
    if (!list.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var PITCH = 13, RAD = 3, MAXRAD = 6;

    Array.prototype.forEach.call(list, function (cv) {
      if (cv.dataset.dotsInit === '1') return; cv.dataset.dotsInit = '1';
      var ctx = cv.getContext('2d'), pattern = cv.dataset.pattern;
      var cols = 1, rows = 1, raf = null, t0 = null, running = false;
      var rect = null;
      var clicks = [];                                  /* concurrent click impulses {x,y (css px), t0} */
      var CI_DECAY = 1 / 1.6;                            /* each impulse eases 1→0 over ~1.6s */

      function size() {
        var w = cv.clientWidth, h = cv.clientHeight;
        if (!w || !h) return;
        cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
        cols = Math.max(2, Math.round(w / PITCH)); rows = Math.max(2, Math.round(h / PITCH));
      }
      function draw(now) {
        if (t0 === null) t0 = now;
        var t = (now - t0) / 1000;
        var W = cv.width, H = cv.height, pc = W / cols, pr = H / rows;
        var csx = (W / dpr) / cols, csy = (H / dpr) / rows;   /* css-px cell size */
        ctx.clearRect(0, 0, W, H);

        /* ── motif-space transform (mirror intensity()): center=(0,0),
           unit = half panel HEIGHT so circles stay round. ── */
        var mcx = (cols - 1) / 2, mcy = (rows - 1) / 2;
        var munit = (rows - 1) / 2; if (munit < 1e-6) munit = 1e-6;
        var RCAP = MAXRAD * 1.4 * dpr;

        /* Resolve active click impulses → motif coords. Each click is independent,
           so rapid re-clicks STACK (overlapping waves) instead of resetting. */
        var act = null;
        if (clicks.length) {
          var live = [];
          for (var ck = 0; ck < clicks.length; ck++) {
            var c = clicks[ck];
            var cSince = t - c.t0;
            var cLife = 1 - cSince * CI_DECAY;
            if (cLife <= 0) continue;                     /* fully decayed → drop */
            live.push(c);
            var cgx = c.x / csx - 0.5, cgy = c.y / csy - 0.5;
            (act || (act = [])).push({
              cnx: (cgx - mcx) / munit, cny: (cgy - mcy) / munit,
              ci: cLife * cLife, tSince: cSince
            });
          }
          clicks = live;                                  /* prune expired */
        }

        for (var gy = 0; gy < rows; gy++) {
          for (var gx = 0; gx < cols; gx++) {
            var v = intensity(pattern, gx, gy, cols, rows, t);
            var op = 0.07 + 0.93 * Math.pow(clamp01(v), 1.6);
            var r = RAD * dpr;
            var nx = (gx - mcx) / munit, ny = (gy - mcy) / munit;

            if (act) {                                    /* per-card CLICK — overlapping impulses stack */
              var addOp = 0, rExtra = 0;
              for (var ai = 0; ai < act.length; ai++) {
                var a = act[ai];
                var rx = reaction(pattern, nx, ny, v, a.cnx, a.cny, a.ci, a.tSince, t);
                addOp += rx.addOp; rExtra += rx.rMul - 1;
              }
              op = clamp01(op + addOp);
              r *= (1 + rExtra);
              if (r > RCAP) r = RCAP;
            }
            ctx.beginPath();
            ctx.arc(pc * (gx + 0.5), pr * (gy + 0.5), r, 0, 6.2832);
            ctx.fillStyle = 'rgba(252, 95, 43,' + op.toFixed(3) + ')';
            ctx.fill();
          }
        }
        if (running || clicks.length > 0) { raf = window.requestAnimationFrame(draw); } else { raf = null; }
      }
      function ensure() { if (raf === null) raf = window.requestAnimationFrame(draw); }
      function start() { running = true; ensure(); }
      function stop() { running = false; }                   /* loop coasts out once impulses decay */

      size();
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { size(); rect = null; if (raf === null) draw(window.performance.now()); }).observe(cv);
      }
      if (reduce) { draw(window.performance.now()); return; } /* static base-pattern frame */

      /* Click / tap fires that card's signature reaction — bound on ALL devices
         (touch included). Reduced-motion returned above, so this stays unbound. */
      var fireClick = function (clientX, clientY) {
        rect = cv.getBoundingClientRect();
        if (t0 === null) t0 = window.performance.now();
        var nowT = (window.performance.now() - t0) / 1000;   /* on the draw clock */
        clicks.push({ x: clientX - rect.left, y: clientY - rect.top, t0: nowT });
        if (clicks.length > 8) clicks.shift();               /* cap concurrent impulses */
        ensure();
      };
      cv.addEventListener('pointerdown', function (e) { fireClick(e.clientX, e.clientY); }, { passive: true });
      if (!window.PointerEvent) {
        cv.addEventListener('touchstart', function (e) {
          var tt = e.changedTouches && e.changedTouches[0]; if (!tt) return;
          fireClick(tt.clientX, tt.clientY);
        }, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0 }).observe(cv);
      } else { start(); }
    });
  }

  /* ── Rive runtime init (for any card using a .riv) ──────────── */
  function initRive() {
    if (!document.querySelector('canvas[data-riv]')) return;
    if (!window.rive || !window.rive.Rive) { window.setTimeout(initRive, 100); return; }
    document.querySelectorAll('canvas[data-riv]').forEach(function (c) {
      if (c.dataset.riveInit === '1') return; c.dataset.riveInit = '1';
      var opts = {
        src: c.dataset.riv, canvas: c, autoplay: true,
        layout: new window.rive.Layout({ fit: window.rive.Fit.Contain, alignment: window.rive.Alignment.Center }),
        onLoad: function () { try { r.resizeDrawingSurfaceToCanvas(); } catch (e) {} }
      };
      if (c.dataset.rivSm) { opts.stateMachines = c.dataset.rivSm; }
      var r = new window.rive.Rive(opts);
      var tm;
      window.addEventListener('resize', function () {
        clearTimeout(tm);
        tm = window.setTimeout(function () { try { r.resizeDrawingSurfaceToCanvas(); } catch (e) {} }, 150);
      }, { passive: true });
    });
  }

  /* ── convergence diagram reveal (the "Synergistic blends" SVG) ──
     Adds .is-in once it scrolls into view so the CSS draw-in plays. The
     continuous loops (node pulse, travelling spark) are CSS, gated on
     prefers-reduced-motion. */
  function initConverge() {
    var list = document.querySelectorAll('.sbf-converge');
    if (!list.length) return;

    /* Replay control — these graphics play a one-shot draw-in that finishes in a
       few seconds; the button re-runs it by resetting + re-adding .is-in. */
    function addReplay(el) {
      if (el.querySelector('.cv-replay')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cv-replay';
      btn.setAttribute('aria-label', 'Replay animation');
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 2.6-6.3"/><polyline points="3 3 3 8 8 8"/></svg>';
      btn.addEventListener('click', function () {
        el.classList.remove('is-in');
        void el.getBoundingClientRect();             /* force reflow so the reset frame applies */
        window.requestAnimationFrame(function () { el.classList.add('is-in'); });
      });
      el.appendChild(btn);
    }

    /* Anchor arrivals land mid-page without a scroll, where IO delivery is
       least reliable — play the draw-ins immediately on a hash entry. */
    if (!('IntersectionObserver' in window) || window.location.hash) {
      Array.prototype.forEach.call(list, function (el) { addReplay(el); el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(list, function (el) { addReplay(el); io.observe(el); });
    /* Fallback: reveal anything still hidden after a moment (IO callbacks can
       stall after fast scrolls — same guard the sci-stack cards use). */
    window.setTimeout(function () {
      Array.prototype.forEach.call(list, function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 1200);
  }

  function boot() { initDots(); initRive(); initConverge(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
